document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".v2-top-slider")) {
    mvBlock: {
      // v2-top-slider
      // 自動再生: OS のモーション低減設定時は無効化（プログレス/一時停止UIもCSS側で非表示）
      const prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;
      const mainOpts = {
        autoplay: !prefersReducedMotion,
        type: "loop",
        pagination: true,
        arrows: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        interval: 5000,
        speed: 300,
        i18n: {
          play: "スライドの自動再生を再開",
          pause: "スライドの自動再生を一時停止",
        },
        perPage: 1,
        fixedWidth: "1080px",
        padding: "calc((100% - 1080px) / 2)",
        lazyLoad: "nearby",
        preloadPages: 1,
        flickPower: 300,
        gap: 10,
        breakpoints: {
          1080: {
            fixedWidth: "calc((350 / 390) * 100vw)",
            padding: "calc((20 / 390) * 100vw)",
            gap: 8,
            arrows: false,
          },
        },
      };
      const mvRoot = document.querySelector(".js-splide-top-main");
      /* 移行済みページは共通スライダー v2-rail.js（進捗バー・一時停止トグルも V2Rail 側） */
      if (window.__v2RailPage || typeof Splide === "undefined") {
        window.V2Rail.fromSplide(mvRoot, mainOpts, { toggle: mvRoot.querySelector(".mv-autoplay-toggle") });
        break mvBlock;
      }
      const splide_top_main = new Splide(".js-splide-top-main", mainOpts);
      // アクティブドットを進捗バー化: autoplay の進捗率(0-1)を CSS 変数へ
      splide_top_main.on("autoplay:playing", function (rate) {
        mvRoot.style.setProperty("--mv-progress", rate);
      });

      // 一時停止トグル: 要素をJSで保持し、ページネーション（ドット列）の末尾に挿入。
      // refresh() でページネーションが再生成されても pagination:mounted で再挿入する。
      // Splideネイティブの splide__toggle は refresh で束縛が外れるため、Autoplay を直接制御。
      const mvToggle = mvRoot.querySelector(".mv-autoplay-toggle");
      const mvAutoplay = function () {
        return splide_top_main.Components.Autoplay;
      };
      const updateToggle = function () {
        if (!mvToggle) return;
        const paused = mvAutoplay().isPaused();
        mvToggle.classList.toggle("is-paused", paused);
        mvToggle.setAttribute(
          "aria-label",
          paused ? "スライドの自動再生を再開" : "スライドの自動再生を一時停止"
        );
      };
      const appendToggleToPagination = function () {
        const pagination = mvRoot.querySelector(".splide__pagination");
        if (!mvToggle || !pagination) return;
        const li = document.createElement("li");
        li.className = "mv-autoplay-toggle-item";
        li.setAttribute("role", "presentation");
        li.appendChild(mvToggle);
        pagination.appendChild(li);
      };
      if (mvToggle) {
        mvToggle.addEventListener("click", function () {
          if (mvAutoplay().isPaused()) {
            mvAutoplay().play();
          } else {
            mvAutoplay().pause();
          }
          updateToggle();
        });
      }
      splide_top_main.on("pagination:mounted", appendToggleToPagination);
      splide_top_main.on("autoplay:play", updateToggle);
      splide_top_main.on("autoplay:pause", updateToggle);
      // 一時停止中の手動送りで前スライドの進捗が残らないようリセット
      splide_top_main.on("move", function () {
        if (mvAutoplay().isPaused()) {
          mvRoot.style.setProperty("--mv-progress", 0);
        }
      });

      splide_top_main.mount();
      appendToggleToPagination();
      updateToggle();

      // Loop modeの初期位置ずれを修正（トップページindex.jsと同等の対策）
      var fixPosition = function () {
        splide_top_main.refresh();
      };
      requestAnimationFrame(function () {
        requestAnimationFrame(fixPosition);
      });
      setTimeout(fixPosition, 150);
    }
  }
  // Check if an element with the class .js-splide-top-info exists
  if (document.querySelector(".js-splide-top-info")) {
    // If it exists, initialize the Splide slider
    // info slider
    const splide_top_info = v2Splide(".js-splide-top-info", {
      autoplay: true,
      type: "slide",
      pagination: false,
      arrows: true,
      interval: 1000,
      speed: 4000,
      // fixedWidth: 530,
      // gap: 20,
      perPage: 1,
      drag: true,
      start: 0,
      breakpoints: {
        1080: {
          fixedWidth: 288,
          gap: 10,
          arrows: false,
        },
      },
    });
    splide_top_info.mount();
  }

  if (document.querySelector(".js-splide-top-new-product")) {
    {
      //new products slider
      const splide_top_new_product = v2Splide(".js-splide-top-new-product", {
        autoplay: false,
        type: "slide",
        pagination: false,
        arrows: true,
        interval: 1000,
        speed: 300,
        fixedWidth: 255,
        gap: 20,
        perPage: 1,
        drag: true,
        start: 0,
        breakpoints: {
          1080: {
            fixedWidth: 110,
            gap: 10,
            arrows: false,
          },
        },
      });
      splide_top_new_product.mount();
    }
  }

  const futureSplides = document.querySelectorAll(".js-future-list-splide");
  futureSplides.forEach((splideRoot) => {
    const items = splideRoot.querySelectorAll(".item");
    if (items.length <= 4) {
      return;
    }

    const mediaQuery = window.matchMedia("(min-width: 1080px)");
    let instance = null;
    const container = splideRoot.closest(".future-list");

    const enable = () => {
      if (instance || !mediaQuery.matches) {
        return;
      }
      splideRoot.classList.add("splide");
      if (container) {
        container.classList.add("is-splide-enabled");
      }
      instance = v2Splide(splideRoot, {
        type: "slide",
        perPage: 4,
        perMove: 1,
        gap: 20,
        pagination: false,
        arrows: true,
        drag: true,
        speed: 300,
      });
      instance.mount();
    };

    const disable = () => {
      if (!instance) {
        return;
      }
      instance.destroy(true);
      instance = null;
      splideRoot.classList.remove("splide");
      if (container) {
        container.classList.remove("is-splide-enabled");
      }
    };

    const handleResize = () => {
      if (mediaQuery.matches) {
        enable();
      } else {
        disable();
      }
    };

    handleResize();
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", handleResize);
    } else {
      mediaQuery.addListener(handleResize);
    }
  });
});
